import { observer } from "mobx-react-lite";
import * as React from "react";

import { MfErrorsListCollapsed } from "./MfErrorsListCollapsed";
import { MfErrorsListExpanded } from "./MfErrorsListExpanded";
import { MfErrorsListStore } from "./MfErrorsListStore";

type PropsMfErrorsListView = {
  store: MfErrorsListStore;
};

export const MfErrorsListView: React.FC<PropsMfErrorsListView> = observer(
  ({ store }) => {
    const { mode, allErrors } = store;
    React.useEffect(() => {
      if (mode === "hidden" && allErrors.length > 0) {
        // Событие, связанное с появлением новых ошибок. нужно перевести в свёрнутое состояние.
        store.collapse();
      }
    }, [mode, allErrors.length]);
    if (mode === "collapsed") return <MfErrorsListCollapsed store={store} />;
    if (mode === "expanded") return <MfErrorsListExpanded store={store} />;
    return null;
  },
);
